import { useState } from "react";
import { CreditCard, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useServices } from "@/context/ServicesContext";
import { daysBetween, formatDate } from "@/lib/services";

const REMIND_DAYS = 5;

export const RenewalReminder = () => {
  const { user } = useAuth();
  const { today, openBilling } = useServices();
  const b = user?.billing;
  const key = `ciclo-renewal-dismissed-${b?.paid_until}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(key) === "1");
  if (!b || b.exempt || user.tenant_role !== "owner" || !b.subscribed || b.cancel_at_period_end || dismissed) return null;
  if (!["active", "trial"].includes(b.status) || !b.paid_until) return null;
  const days = daysBetween(today, b.paid_until);
  if (days < 0 || days > REMIND_DAYS) return null;
  const when = days === 0 ? "hoje" : days === 1 ? "amanhã" : `em ${days} dias (${formatDate(b.paid_until)})`;

  const dismiss = () => {
    localStorage.setItem(key, "1");
    setDismissed(true);
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-sky-500/40 bg-sky-500/10 px-4 py-3 text-sm" data-testid="renewal-reminder">
      <span className="text-sky-100">Sua próxima cobrança é <b>{when}</b>. Confira se o cartão está em dia para não perder o acesso.</span>
      <div className="flex items-center gap-1">
        <Button size="sm" onClick={openBilling} className="rounded-full" data-testid="renewal-reminder-manage"><CreditCard className="mr-1 h-3.5 w-3.5" /> Ver cartão</Button>
        <Button size="icon" variant="ghost" className="h-8 w-8 text-slate-400" onClick={dismiss} aria-label="Dispensar aviso" data-testid="renewal-reminder-dismiss"><X className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
